import { Ref } from 'react';

interface IHandleProps {
  style: React.CSSProperties;
  handleRef: Ref<HTMLDivElement>;
}

const Handle: React.FC<IHandleProps> = ({ style, handleRef, ...props }) => {
  return (
    <>
      <div
        className="container"
        ref={handleRef}
        {...props}
        style={{ ...style }}
      ></div>
      <style jsx>{`
        .container {
          width: 25px;
          height: 25px;
          top: -5px;
          z-index: var(--zindex-sticky);
          background: var(--white);
          border: 1.5px solid var(--black);
          border-radius: var(--rd-round);
          cursor: pointer;
        }
      `}</style>
    </>
  );
};

export default Handle;
